/* Sleep homepage — Modular Pillow chapter. Desktop: one sticky plate cross-fades between beats as their text passes the viewport centre.
   No pinning, no scroll-jacking; phones and no-JS get the stacked layout from CSS alone.
   Each beat's media exists once: on desktop it is moved into the plate's slide, on phones it is moved back under its beat.
   Playback is owned here (core's 35% observer is bypassed with data-dts-manual): desktop plays the active slide only,
   phones play only the on-screen clip nearest the middle of the screen, so two beats never run at once. */
(function () {
  'use strict';
  function mod(main, DTS) {
    var root = main.querySelector('#dts-mp'); if (!root) return;
    var beats = [].slice.call(root.querySelectorAll('[data-dts-mp-beat]'));
    var slides = [].slice.call(root.querySelectorAll('[data-dts-mp-slide]'));
    var ticks = [].slice.call(root.querySelectorAll('.dts-mp__ticks i'));
    var plate = root.querySelector('[data-dts-mp-plate]');
    var holders = beats.map(function (b) { return b.querySelector('[data-dts-mp-holder]'); });
    var medias = holders.map(function (h) { return h && h.querySelector('.dts-mp__media'); });
    if (!beats.length || !slides.length || !plate || !('IntersectionObserver' in window)) return;

    var mq = window.matchMedia('(min-width: 990px)');
    var active = 0, plateIn = false, live = false, ratios = [];
    var vids = medias.map(function (m) {
      var v = m && m.querySelector('video'); if (!v) return null;
      v.dataset.dtsManual = '1';
      v.addEventListener('playing', function () { m.classList.add('is-playing'); });
      return v;
    });

    /* the one place a clip is started: index i plays, every other clip pauses */
    function play(i) {
      vids.forEach(function (v, k) {
        if (!v) return;
        if (k === i && !DTS.reduce && (!live || plateIn)) {
          if (!v.src && v.dataset.src) { v.src = (window.DTS && DTS.pickSrc) ? DTS.pickSrc(v) : v.dataset.src; v.load(); }
          v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }
    function set(i) {
      if (i === active && root.__mpSet) { play(i); return; }
      root.__mpSet = true; active = i;
      beats.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      ticks.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      play(i);
    }

    /* desktop: which beat sits in the middle 10% of the viewport */
    var centre = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) set(beats.indexOf(en.target)); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    /* desktop: is the plate itself on screen (so hidden videos never run) */
    var seen = new IntersectionObserver(function (es) {
      es.forEach(function (en) { plateIn = en.isIntersecting; play(active); });
    }, { threshold: 0.2 });

    /* phones: of the clips at least 35% on screen, only the one nearest the middle of the screen plays */
    var nearest = new IntersectionObserver(function (es) {
      es.forEach(function (en) { ratios[medias.indexOf(en.target)] = en.isIntersecting ? en.intersectionRatio : 0; });
      pick();
    }, { threshold: [0, .35, .5, .65, .8, 1] });
    function pick() {
      if (live) return;
      var best = -1, bd = Infinity, mid = window.innerHeight / 2;
      medias.forEach(function (m, k) {
        if (!vids[k] || !(ratios[k] >= .35)) return;
        var r = m.getBoundingClientRect(), d = Math.abs((r.top + r.bottom) / 2 - mid);
        if (d < bd) { bd = d; best = k; }
      });
      play(best);
    }

    /* one copy of each beat's media: into the plate on desktop, back under its beat on phones */
    function place(toPlate) {
      medias.forEach(function (m, k) {
        if (!m) return; var dest = toPlate ? slides[k] : holders[k];
        if (dest && m.parentNode !== dest) dest.appendChild(m);
      });
    }

    function apply() {
      live = mq.matches;
      root.classList.toggle('dts-mp--live', live);
      place(live);
      if (live) {
        medias.forEach(function (m) { if (m) nearest.unobserve(m); }); ratios = [];
        beats.forEach(function (b) { centre.observe(b); }); seen.observe(plate);
        set(active);
      } else {
        beats.forEach(function (b) { centre.unobserve(b); }); seen.unobserve(plate); plateIn = false;
        play(-1);
        medias.forEach(function (m) { if (m) nearest.observe(m); });
      }
      if (DTS.remeasure) DTS.remeasure();
    }
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
  }
  if (window.DTS && window.DTS.register) window.DTS.register('mp', mod);
  else { window.DTS = window.DTS || {}; (window.DTS.modules = window.DTS.modules || []).push({ name: 'mp', fn: mod }); }
})();
